export const Validations = {
  nameInvalidLengthRegex: /^(.){2,50}$/,
  nameInvalidLengthErrorMsg: "The name must be between 2 and 50 characters.",

  nameInvalidCharactersRegex: /^([a-zA-Ÿ \-'_]|\d){2,50}$/,
  nameInvalidCharactersErrorMsg:
    "The name uses invalid characters. Enter letters, numbers, single quotes, hyphens or spaces.",

  idInvalidLengthRegex: /^(.){6,50}$/,
  idInvalidLengthErrorMsg: "The id must be between 6 and 50 characters.",

  idInvalidCharactersRegex: /^[a-z\d]([\d\-_]|[a-z]){4,50}[a-z\d]$/,
  idInvalidCharactersErrorMsg:
    "The id uses invalid characters. Enter lowercase letters, numbers or hyphens.",

  idInformMsg:
    "Id can have lowercase letters, digits, or hyphens. It must start with a lowercase letter and end with a letter or number.",

  isIntegrationMrn:
    /(^\/\/integration.api.mondoo.app)(\/spaces\/).*(\/aws|managed\/).*/,

  isNumber: /^[0-9]*$/,
};
